import React, { Component } from 'react';
import { connect } from 'react-redux';

import config from '../../config';

import { cleanString } from '../../util/renderHelper';
import { getSlug, getProvider } from '../../util/url';

import { Button, Col, Dropdown, Menu, Modal, Row } from 'antd';
import { ReactComponent as IconChevronRight } from '../Sprites/icon-chevron-right.svg';
import { ReactComponent as IconClose } from '../Sprites/icon-close.svg';
import ProviderTypeToggle from './ProviderTypeToggle';

/* Tidy and sort list of providers.
 */
const listProviders = (providers, dashboardLandingURL) =>
  providers
    .filter(
      provider =>
        !!provider.name.trim().length &&
        !!provider.category.trim().length &&
        !!provider.slug.trim().length
    )
    .filter(
      provider => provider.slug !== getSlug(window.location.href, providers)
    )
    .map(provider => ({
      ...provider,
      url: `${dashboardLandingURL}/${provider.slug}`
    }))
    .sort((a, b) => {
      const aName = a.name.trim().toLowerCase();
      const bName = b.name.trim().toLowerCase();
      if (aName < bName) {
        return -1;
      }
      if (aName > bName) {
        return 1;
      }
      return 0;
    });

const ModalBodyDesktop = ({ providers }) => {
  const healthProviders = providers.filter(
    provider =>
      provider.category.toLowerCase().trim() ===
      'allied health & medical'
  );
  const otherProviders = providers.filter(
    provider => provider.category.toLowerCase().trim() === 'other'
  );

  const grupProviders = providers
    .filter(
      provider =>
        provider.category.toLowerCase().trim() !== 'other' &&
        provider.category.toLowerCase().trim() !==
          'allied health & medical'
    )
    .reduce(
      (result, item) => ({
        ...result,
        [item['category']]: [...(result[item['category']] || []), item]
      }),
      {}
    );

  return !!healthProviders.length || otherProviders.length ? (
    <Row gutter={{ lg: 20 }}>
      {!!healthProviders.length ? (
        <ProvidersHealth providers={healthProviders} />
      ) : null}
      {Object.keys(grupProviders).length > 0 ? (
        <GrupProviders grupProviders={grupProviders} />
      ) : null}
      {!!otherProviders.length ? (
        <ProvidersOther providers={otherProviders} />
      ) : null}
    </Row>
  ) : null;
};

const ModalBodyMobile = ({ providers }) => {
  return (
    <Row>
      <Col xs={{ span: 24 }} lg={{ span: 0 }}>
        <Dropdown
          overlay={<ProviderMenu providers={providers} />}
          trigger={['click']}
          className="provider-type-modal__dropdown"
        >
          <Button>Select from list</Button>
        </Dropdown>
      </Col>
    </Row>
  );
};

const ModalFooter = ({ clickAction }) => [
  <span key="footer-text" className="provider-type-modal__footer-text">
    or
  </span>,
  <Button
    key="footer-cancel"
    type="primary"
    onClick={clickAction}
    className="provider-type-modal__footer-cancel"
  >
    Continue without
  </Button>
];

const ModalIntro = () => (
  <div className="provider-type-modal__intro">
    <Row>
      <Col xs={{ span: 24 }} lg={{ span: 18 }}>
        <p>
          Please choose the category that best relates to your profession for
          associated fees, guidelines, clinical resources, research and forms
          and brochures relevant to you.
        </p>
      </Col>
    </Row>
    <div className="provider-type-modal__intro-triangle"></div>
  </div>
);

const ProviderListItem = ({ provider }) => {
  const isCurrentProvider =
    (window.localStorage && window.localStorage.getItem('tac-provider')) ===
    provider.id
      ? ' current'
      : '';
  return (
    <li className="provider-type-modal__item">
      <span className="provider-type-modal__bullet">
        <IconChevronRight />
      </span>
      <a
        href={provider.url}
        className={`provider-type-modal__link${isCurrentProvider}`}
        onClick={() =>
          window.localStorage &&
          window.localStorage.setItem('tac-provider', provider.id)
        }
      >
        {isCurrentProvider ? (
          <>
            <span className="name">{cleanString(provider.name)}</span>
            <span className="selected">Selected</span>
          </>
        ) : (
          cleanString(provider.name)
        )}
      </a>
    </li>
  );
};

const ProviderMenu = ({ providers }) => {
  const displatProviderMenuItem = providers.map((provider, key) => (
    <ProviderMenuItem key={`provider-menu-item-${key}`} provider={provider} />
  ));
  return (
    <Menu className="provider-type-modal__menu">{displatProviderMenuItem}</Menu>
  );
};

class ProviderMenuItem extends Component {
  render() {
    const itemProps = {
      ...this.props
    };
    delete itemProps.provider;
    return (
      <Menu.Item {...itemProps}>
        <a href={this.props.provider.url}>
          {cleanString(this.props.provider.name)}
        </a>
      </Menu.Item>
    );
  }
}

class ProvidersHealth extends Component {
  render(props) {
    const providers = this.props.providers;
    const columnMax = !!providers.length ? Math.ceil(providers.length / 2) : 0;
    return (
      <Col xs={{ span: 0 }} lg={{ span: 12 }}>
        <h2 className="provider-type-modal__category-heading">
          Allied Health &amp; Medical
        </h2>
        <Row>
          <Col xs={{ span: 0 }} lg={{ span: 12 }}>
            <ul className="provider-type-modal__list">
              {providers.slice(0, columnMax).map((provider, key) => (
                <ProviderListItem
                  key={`health-provider-${key}`}
                  provider={provider}
                />
              ))}
            </ul>
          </Col>
          <Col xs={{ span: 0 }} lg={{ span: 12 }}>
            {providers.length > 1 ? (
              <ul className="provider-type-modal__list">
                {providers
                  .slice(columnMax, 2 * columnMax)
                  .map((provider, key) => (
                    <ProviderListItem
                      key={`health-provider-${key}`}
                      provider={provider}
                    />
                  ))}
              </ul>
            ) : null}
          </Col>
          <Col xs={{ span: 0 }} lg={{ span: 12 }}>
            {providers.length > 2 ? (
              <ul className="provider-type-modal__list">
                {providers
                  .slice(2 * columnMax, providers.length)
                  .map((provider, key) => (
                    <ProviderListItem
                      key={`health-provider-${key}`}
                      provider={provider}
                    />
                  ))}
              </ul>
            ) : null}
          </Col>
        </Row>
      </Col>
    );
  }
}

class ProvidersOther extends Component {
  render(props) {
    const providers = this.props.providers;
    return (
      <Col xs={{ span: 0 }} lg={{ span: 6 }}>
        <h2 className="provider-type-modal__category-heading">Other</h2>
        <ul className="provider-type-modal__list">
          {providers.map((provider, key) => (
            <ProviderListItem
              key={`other-provider-${key}`}
              provider={provider}
            />
          ))}
        </ul>
      </Col>
    );
  }
}

const GrupProviders = ({ grupProviders }) => {
  const displayGrupProviders = Object.keys(grupProviders).map(grupProvider => (
    <Col
      key={`grup-provider-${grupProvider}`}
      xs={{ span: 0 }}
      lg={{ span: 24 }}
    >
      <h2 className="provider-type-modal__category-heading">{grupProvider}</h2>
      <ul className="provider-type-modal__list">
        {grupProviders[grupProvider].map((provider, key) => (
          <ProviderListItem
            key={`other-provider--${grupProvider}-${key}`}
            provider={provider}
          />
        ))}
      </ul>
    </Col>
  ));
  return (
    <Col xs={{ span: 0 }} lg={{ span: 6 }}>
      {displayGrupProviders}
    </Col>
  );
};

class ProviderTypeModal extends Component {
  state = {
    visible: false
  };
  checkLocalStorage() {
    if (!window.localStorage) {
      return;
    }

    !window.localStorage.getItem('tac-provider')
      ? this.showModal()
      : this.handleCancel();
  }
  showModal = () => {
    this.setState({
      visible: true
    });
  };
  handleCancel = () => {
    this.setState({
      visible: false
    });
  };
  componentDidMount = () => {
    const locationParam = window.location.search
    if ( locationParam.indexOf('modal=true') > -1) {
      this.showModal();
    }
  }
  render() {
    const { visible } = this.state;
    const dashboardLandingURL = `${config.APP_URL}${config.APP_PATH}`;
    const validProviders = this.props.providers.length
      ? listProviders(this.props.providers, dashboardLandingURL)
      : [];
    return !!validProviders.length
      ? [
          <ProviderTypeToggle
            key="provider-type-toggle"
            clickAction={this.showModal}
            provider={getProvider(this.props.providers)}
          />,
          <Modal
            key="provider-type-modal"
            title="For service providers"
            className="provider-type-modal"
            closeIcon={<IconClose />}
            onCancel={this.handleCancel}
            footer={<ModalFooter clickAction={this.handleCancel} />}
            visible={visible}
            width={1280}
          >
            <ModalBodyMobile providers={validProviders} />
            <ModalBodyDesktop providers={validProviders} />
          </Modal>
        ]
      : null;
  }
}

const mapStateToProps = state => ({
  providers: state.providers.data
});

export default connect(mapStateToProps)(ProviderTypeModal);
